import { MainRecommendations } from "../pages/recommendation";

const Request = () => <MainRecommendations title="Request" />;

export default Request;
